class ApprovalBeforeRequestDto {
  /** 业务Key，例如盘点单号 */
  businessKey = "";

  /** 页大小 */
  pageNumber = undefined;

  /** 页号 */
  pageSize = undefined;

  /** 流程定义key,盘点：InventoryApproval */
  processKey = "";
}

class ApprovalRequestDto {
  /** 审批状态：待提交：-1，已驳回：0；已通过<流程结束传>：1；审批中<只要流程没结束都是传该状态>：2；已撤回：3 ；已挂起：4；已删除：5；流程终止：-2 */
  approvalStatus = undefined;

  /** 审批意见 */
  approvalSug = "";

  /** 审批流程号 */
  businessKey = "";

  /** 表单数据 */
  formData = undefined;

  /** 本次操作 */
  operateTaskDto = new CurrentTaskDto();

  /** 流程实例id */
  processInstanceId = "";

  /** 流程定义key */
  processKey = "";

  /** 是否需要开启审批流 */
  startApproval = false;

  /** 驳回目标节点 */
  taskDto = new TaskDto();
}

class AssigneeDto {
  /** 操作人内部编号 */
  userCode = "";

  /** 操作人名称 */
  userName = "";
}

class AssociatedFilesResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 文件类型 */
  fileCategory = "";

  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 来源标识 */
  sourceId = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class BillInfoImportRequestDto {
  /** 账单币种 */
  billCurrency = "";

  /** 已出账单金额 */
  billedAmount = undefined;

  /** 单据号 */
  erNo = "";

  /** errorMsg */
  errorMsg = "";

  /** reference_number */
  referenceNumber = "";

  /** rowNum */
  rowNum = undefined;

  /** 未出账单金额 */
  unbilledAmount = undefined;
}

class CurrentTaskDto {
  /** 节点当前处理人 */
  currentAssignee = new AssigneeDto();

  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 节点操作类型 驳回指定节点:backToStart；驳回:reject；通过:pass,；反对：oppose；弃权：abandon；终止：cadence */
  operate = "";

  /** 任务id */
  taskId = "";
}

class ExpenseReimbursementDetailRequestDto {
  /** 申请金额 */
  amount = undefined;

  /** 受益部门 */
  benefitDepartment = "";

  /** 受益部门名称 */
  benefitDepartmentName = "";

  /** 预算管控部门 */
  budgetControlDepartment = "";

  /** 预算管控部门名称 */
  budgetControlDepartmentName = "";

  /** 渠道 KOL、KOC、PR、AFF */
  channel = "";

  /** 费用类别 */
  costCategory = "";

  /** 费用明细 */
  costDetail = "";

  /** 费用类型 */
  costType = "";

  /** 申请币种 */
  currency = "";

  /** 说明 */
  description = "";

  /** 汇率 */
  exchangeRate = undefined;

  /** id */
  id = undefined;

  /** 链接 */
  link = "";

  /** 父ID */
  parentId = undefined;

  /** 平台 */
  platform = "";

  /** 项目 */
  project = "";

  /** 站点 */
  site = "";

  /** sku */
  sku = "";
}

class ExpenseReimbursementDetailResponseDto {
  /** 申请金额 */
  amount = undefined;

  /** 受益部门 */
  benefitDepartment = "";

  /** 受益部门名称 */
  benefitDepartmentName = "";

  /** 预算管控部门 */
  budgetControlDepartment = "";

  /** 预算管控部门名称 */
  budgetControlDepartmentName = "";

  /** 渠道 KOL、KOC、PR、AFF */
  channel = "";

  /** 费用类别 */
  costCategory = "";

  /** 费用明细 */
  costDetail = "";

  /** 费用类型 */
  costType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申请币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 说明 */
  description = "";

  /** id */
  id = undefined;

  /** 链接 */
  link = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 父ID */
  parentId = undefined;

  /** 平台 */
  platform = "";

  /** 项目 */
  project = "";

  /** 站点 */
  site = "";

  /** sku */
  sku = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class ExpenseReimbursementRequestDto {
  /** 申请人 */
  applicant = "";

  /** 审核状态  -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 账单币种 */
  billCurrency = "";

  /** 水单附件 */
  billFile = "";

  /** 账单状态 0 未开始 1 待补充 2 已补充 */
  billStatus = undefined;

  /** 已出账单金额 */
  billedAmount = undefined;

  /** 合同附件 */
  contractFile = "";

  /** 申请币种 */
  currency = "";

  /** 单据号 */
  erNo = "";

  /** 费用单附件 */
  expenseReimbursementFile = "";

  /** id */
  id = undefined;

  /** 费用请款明细 */
  itemList = [];

  /** 付款账号名称 */
  paymentAccountName = "";

  /** 付款时间 */
  paymentDate = "";

  /** 款项性质 0 全款 1 收款 2 尾款 */
  paymentNature = undefined;

  /** 付款状态 0 未付款 1 待付款 2 已付款 */
  paymentStatus = undefined;

  /** 单据类型 0 海外推广费 */
  processType = undefined;

  /** 收款账号 */
  recipientAccountNumber = "";

  /** reference_number */
  referenceNumber = "";

  /** 补充附件 */
  replenishFile = "";

  /** 是否经第三方 0 否 1 是 */
  throughThirdParty = false;

  /** 申请总金额 */
  totalAmount = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 未出账单金额 */
  unbilledAmount = undefined;
}

class ExpenseReimbursementRequestParamsDto {
  /** 申请人 */
  applicant = "";

  /** 审核状态  -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 审核状态  -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatusIn = "";

  /** 账单币种 */
  billCurrency = "";

  /** 账单状态 0 未开始 1 待补充 2 已补充 */
  billStatus = undefined;

  /** 账单状态 0 未开始 1 待补充 2 已补充 */
  billStatusIn = "";

  /** 已出账单金额 */
  billedAmount = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建日期-结束 */
  createTimeEnd = "";

  /** 创建日期-开始 */
  createTimeStart = "";

  /** 申请币种 */
  currency = "";

  /** 单据号 */
  erNo = "";

  /** id */
  id = undefined;

  /** 付款账号ID */
  paymentAccountId = "";

  /** 付款账号名称 */
  paymentAccountName = "";

  /** 付款时间 */
  paymentDate = "";

  /** 款项性质 0 全款 1 收款 2 尾款 */
  paymentNature = undefined;

  /** 付款状态 0 未付款 1 待付款 2 已付款 */
  paymentStatus = undefined;

  /** 付款状态 0 未付款 1 待付款 2 已付款 */
  paymentStatusIn = "";

  /** 付款日期-结束 */
  paymentTimeEnd = "";

  /** 付款日期-开始 */
  paymentTimeStart = "";

  /** 单据类型 0 海外推广费 */
  processType = undefined;

  /** 收款账号 */
  recipientAccountNumber = "";

  /** reference_number */
  referenceNumber = "";

  /** 是否经第三方 0 否 1 是 */
  throughThirdParty = false;

  /** 申请总金额 */
  totalAmount = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 未出账单金额 */
  unbilledAmount = undefined;

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class ExpenseReimbursementResponseDto {
  /** 申请人 */
  applicant = "";

  /** 审核状态  -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 账单币种 */
  billCurrency = "";

  /** 水单附件 */
  billFile = "";

  /** 账单状态 0 未开始 1 待补充 2 已补充 */
  billStatus = undefined;

  /** 已出账单金额 */
  billedAmount = undefined;

  /** 合同附件 */
  contractFile = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申请币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 单据号 */
  erNo = "";

  /** 费用单附件 */
  expenseReimbursementFile = "";

  /** id */
  id = undefined;

  /** 费用请款明细 */
  itemList = [];

  /** 版本号 */
  lockVersion = undefined;

  /** 付款账号ID */
  paymentAccountId = "";

  /** 付款账号名称 */
  paymentAccountName = "";

  /** 付款时间 */
  paymentDate = "";

  /** 款项性质 0 全款 1 收款 2 尾款 */
  paymentNature = undefined;

  /** 付款状态 0 未付款 1 待付款 2 已付款 */
  paymentStatus = undefined;

  /** 单据类型 0 海外推广费 */
  processType = undefined;

  /** 收款账号 */
  recipientAccountNumber = "";

  /** reference_number */
  referenceNumber = "";

  /** 是否经第三方 0 否 1 是 */
  throughThirdParty = undefined;

  /** 申请总金额 */
  totalAmount = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 未出账单金额 */
  unbilledAmount = undefined;

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PaymentBankRequestDto {
  /** id */
  id = undefined;

  /** 付款账户ID */
  paymentAccountId = "";

  /** 付款账户名称 */
  paymentAccountName = "";

  /** 第三方账户ID */
  thirdPartyAccountId = "";

  /** 第三方账户名称 */
  thirdPartyAccountName = "";
}

class PaymentBankRequestParamsDto {
  /** 付款账户ID */
  paymentAccountId = "";

  /** 第三方账户ID */
  thirdPartyAccountId = "";
}

class PaymentBankResponseDto {
  /** id */
  id = undefined;

  /** 付款账户ID */
  paymentAccountId = "";

  /** 付款账户名称 */
  paymentAccountName = "";

  /** 第三方账户ID */
  thirdPartyAccountId = "";

  /** 第三方账户名称 */
  thirdPartyAccountName = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new ExpenseReimbursementResponseDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class TaskDto {
  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 任务id */
  taskId = "";
}

export const rms = {
  ApprovalBeforeRequestDto,
  ApprovalRequestDto,
  AssigneeDto,
  AssociatedFilesResponseDto,
  BillInfoImportRequestDto,
  CurrentTaskDto,
  ExpenseReimbursementDetailRequestDto,
  ExpenseReimbursementDetailResponseDto,
  ExpenseReimbursementRequestDto,
  ExpenseReimbursementRequestParamsDto,
  ExpenseReimbursementResponseDto,
  IPage,
  PaymentBankRequestDto,
  PaymentBankRequestParamsDto,
  PaymentBankResponseDto,
  Response,
  ResponseDto,
  TaskDto,
};
